import { Link } from 'react-router-dom';
import { useLang } from '../App';
import { UI, PROJECTS } from '../content';

const sorted = [...PROJECTS].sort((a, b) => parseInt(b.year) - parseInt(a.year));

function ProjectImg({ p }) {
  if (p.img) {
    return (
      <div className="pcard-img">
        <img src={p.img} alt={p.name} />
      </div>
    );
  }
  return (
    <div
      className="pcard-img"
      style={{ backgroundImage: p.imgGradient, backgroundColor: '#111' }}
    >
      <div className="pcard-placeholder">
        <div className="pcard-placeholder-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ color: '#fff' }}>
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <path d="M21 15l-5-5L5 21" />
          </svg>
        </div>
        <span className="pcard-placeholder-text">image</span>
      </div>
    </div>
  );
}

export default function Projects() {
  const { lang } = useLang();
  const t = UI[lang];

  return (
    <>
      <div className="main">

        <section className="projects-page-hero">
          <Link to="/" className="back-link">← {t.nav.home}</Link>
          <h1 className="projects-page-title">{t.projectsPage.title}</h1>
          <p className="projects-page-subtitle">{t.projectsPage.subtitle}</p>
        </section>

        <div className="projects-grid">
          {sorted.map((p) => (
            <div className="pcard" key={p.id}>

              <div style={{ position: 'relative' }}>
                <ProjectImg p={p} />
                {p.github && (
                  <a
                    href={p.github}
                    target="_blank"
                    rel="noreferrer"
                    className="pcard-img-link"
                  >
                    GitHub ↗
                  </a>
                )}
                {p.website && (
                  <a
                    href={p.website}
                    target="_blank"
                    rel="noreferrer"
                    className="pcard-img-link"
                  >
                    Website ↗
                  </a>
                )}
              </div>

              <div className="pcard-body">
                <div className="pcard-header">
                  {p.github ? (
                    <a href={p.github} target="_blank" rel="noreferrer" className="pcard-name">
                      {p.name}
                    </a>
                  ) : (
                    <span className="pcard-name">{p.name}</span>
                  )}
                  <span className="pcard-year">{p.year}{p.ongoing ? ' →' : ''}</span>
                </div>

                <div className="pcard-meta">
                  <span className="pcard-lang">{p.primary}</span>
                  {p.stat && (
                    <>
                      <span className="pcard-dot" />
                      <span className="pcard-stat">{p.stat[lang]}</span>
                    </>
                  )}
                  {p.ongoing && (
                    <>
                      <span className="pcard-dot" />
                      <span className="pcard-ongoing">{t.ongoing}</span>
                    </>
                  )}
                </div>

                <p className="pcard-desc">{p.desc[lang]}</p>

                {p.tags.length > 0 && (
                  <div className="pcard-tags">
                    {p.tags.map((tag) => (
                      <span className="tag" key={tag}>{tag}</span>
                    ))}
                  </div>
                )}
              </div>

            </div>
          ))}
        </div>

      </div>

      <footer className="footer" style={{ marginTop: '4rem' }}>
        <p className="footer-text">
          Adam Elaoumari · {t.footer} · {new Date().getFullYear()}
        </p>
      </footer>
    </>
  );
}
